export default __webpack_public_path__ + "static/media/lamp.c047053d.svg";